import styled from "styled-components";

import { PrimaryButton } from "components/Button";

interface ISectionProps {
  title?: string;
  type?: string;
  size?: string;
}

export const ModalContainer = styled.div`
  z-index: 9999;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ModalBackdrop = styled.div`
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  z-index: 0;
  background-color: ${({ theme }) => theme.customTheme.palette.semiTransparentBackground.standard};
`;

export const StyledContainer = styled.section<ISectionProps>`
  border-radius: 12px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  z-index: 1;
  position: absolute;
  width: 340px;
  min-height: 348px;
  max-height: ${({ size }) => (size === "small" ? "348px" : "708px")};
  background-color: ${({ theme }) => theme.customTheme.palette.white.standard};
  display: flex;
  flex-direction: column;
  align-items: ${({ type }) => (type === "logout" ? "center" : "flex-start")};
  justify-content: center;
  padding: 36px 30px;
  gap: 16px;
  box-shadow: 0px 12px 25px rgba(0, 0, 0, 0.15);

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    width: ${({ type }) => (type === "error" || type === "cancelation" || type === "cookies" ? "448px" : "682px")};
    padding: 48px 72px;
  }
`;

export const ErrorStyledContainer = styled(StyledContainer)`
  width: 327px;
  height: ${({ size }) => (size === "small" ? "396px" : "456px")};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 24px;
  gap: 24px;
`;

export const StyledCookieContainer = styled(StyledContainer)`
  width: 327px;
  min-height: 348px;
  max-height: ${({ size }) => (size === "small" ? "348px" : "708px")};
  display: flex;
  flex-direction: column;
  align-items: ${({ type }) => (type === "logout" ? "center" : "flex-start")};
  padding: 68px 30px;

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    width: 377px;
    padding: 68px 30px;
  }
`;

export const CrossBtn = styled.button`
  position: absolute;
  top: ${({ theme }) => theme.customTheme.pxToRem(5)};
  right: ${({ theme }) => theme.customTheme.pxToRem(5)};
  width: ${({ theme }) => theme.customTheme.pxToRem(48)};
  height: ${({ theme }) => theme.customTheme.pxToRem(48)};
  border: none;
  background: transparent;
  cursor: pointer;
`;

export const StyledBigIcon = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    padding-top: 16px;
  }
`;
interface ITextAlignProps {
  $textAlign?: string | null;
}

interface IChildrenWrapperProps {
  $textAlign?: string | null;
  $enableGradient: boolean;
}

export const StyledTitle = styled.h2<ITextAlignProps>`
  width: 100%;
  text-align: ${({ $textAlign }) => $textAlign || "center"};
  margin: 0px auto;
  font-family: ThemeFontBold;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(24)};
  line-height: 32px;
  font-weight: 700;
  color: ${({ theme }) => theme.customTheme.palette.black.black1};
  overflow-wrap: break-word !important;
`;

export const StyledDescription = styled.p<ITextAlignProps>`
  width: 100%;
  text-align: ${({ $textAlign }) => $textAlign || "center"};
  font-family: ThemeFontRegular;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
  line-height: 20px;
  font-weight: 400;
  color: ${({ theme }) => theme.customTheme.palette.grey.grey5E};
  margin: 0px auto;
  word-wrap: break-word;
`;

export const ChildrenWrapper = styled.div<IChildrenWrapperProps>`
  width: 100%;
  font-family: ThemeFontRegular;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
  line-height: 20px;
  font-weight: 400;
  color: ${({ theme }) => theme.customTheme.palette.grey.grey5E};
  text-align: ${({ $textAlign }) => $textAlign || "center"};
  overflow-y: auto;

  * {
    color: ${({ theme }) => theme.customTheme.palette.grey.grey5E};
  }

  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
  max-height: 200px;
  ::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }

  ${({ $enableGradient }) =>
    $enableGradient &&
    `
    :after {
      content: "";
      position: absolute;
      left: 0px;
      right: 0px;
      bottom: 0px;
      height: 30%;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
      pointer-events: none;
      border-radius: 0px 0px 12px 12px;
    }
  `}
`;

export const ButtonContainer = styled.div`
  padding-top: 8px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const DoneButton = styled(PrimaryButton)`
  width: 105px;
  background-color: ${({ theme }) => theme.customTheme.palette.black.black25};
`;

export const StyledHeader = styled.section`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    justify-content: center;
  }
`;

export const StyledCookieTitle = styled.h2`
  font-family: ThemeFontBold;
  font-size: 18px;
  margin: 0px auto;
  margin-bottom: 16px;
  text-align: center;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    font-size: 24px;
  }
`;

export const StyledCookieDescription = styled.p`
  line-height: 24px;
  margin-bottom: 40px;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(18)};
  overflow: auto;

  a {
    color: ${({ theme }) => theme.customTheme.palette.black.black25};
  }
`;

export const StyledButtonsArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    flex-direction: row;
    justify-content: center;
  }
`;

export const StyledCookieButtonsArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const CookiesBtn = styled(PrimaryButton)`
  padding: ${({ theme }) => theme.customTheme.pxToRem(10)} ${({ theme }) => theme.customTheme.pxToRem(24)};
  font-size: ${({ theme }) => theme.customTheme.pxToRem(18)};
  width: 100%;
  background-color: ${({ theme }) => theme.customTheme.palette.black.black25};
`;

export const StyledIcon = styled.i`
  display: flex;
`;
